import { render, staticRenderFns } from "./levelList.vue?vue&type=template&id=acdbe6fc&scoped=true"
import script from "./levelList.vue?vue&type=script&lang=js"
export * from "./levelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdbe6fc",
  null
  
)

export default component.exports